import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionControl, AccordionItem, AccordionPanel } from "@mantine/core";
import PureHtml from "@/components/custom/PureHtml";
export default function FeaturedOptions(t0) {
  const $ = _c(16);
  const {
    featured_options
  } = t0;
  let t1;
  if ($[0] !== featured_options.foptions) {
    t1 = featured_options?.foptions || [];
    $[0] = featured_options.foptions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const foptions = t1;
  const t2 = `section-foptions py-2 lg:py-3 ${featured_options?.style || "style1"}`;
  const t3 = featured_options?.heading || "Featured Options";
  let t4;
  if ($[2] !== t3) {
    t4 = <h2 className="text-xl lg:text-2xl">{t3}</h2>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== featured_options.subtext) {
    t5 = <PureHtml html={featured_options.subtext} />;
    $[4] = featured_options.subtext;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== featured_options.style || $[7] !== foptions) {
    t6 = featured_options?.style === "style3" ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">{foptions?.map(_temp)}</div> : <div className="p-2 bg-white rounded shadow"><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">{foptions?.map((foption_0, index_0) => <Accordion key={index_0} variant="separated" transitionDuration={1000} className="w-full" chevronIconSize={24}><AccordionItem value={foption_0.title}><AccordionControl aria-label={foption_0.title} bg="gray.1" className="rounded-t-lg">{featured_options?.style === "style1" ? <h3 className="text-base lg:text-xl">{foption_0.title}</h3> : <h3 className="text-base lg:text-xl leading-none">{foption_0.title}</h3>}</AccordionControl><AccordionPanel><PureHtml html={foption_0.ftext} /></AccordionPanel></AccordionItem></Accordion>)}</div></div>;
    $[6] = featured_options.style;
    $[7] = foptions;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <div className="max-w-7xl mx-auto px-2">{t4}{t5}{t6}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t7) {
    t8 = <section className={t2} id="featured_options">{t7}</section>;
    $[13] = t2;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function _temp(foption, index) {
  return <div className="p-2 bg-white rounded shadow border border-gray-200" key={index}><h3 className="text-base lg:text-xl leading-none">{foption.title}</h3><PureHtml html={foption.ftext} /></div>;
}